import type { VoidFunctionComponent } from 'react';
import SavedFiltersDropdownList from './SavedFiltersDropdownList';
import SavedFiltersDropdownActions from './SavedFiltersDropdownActions';
import './SavedFilters.less';

/**
 * SavedFilters refers to the two UI components which
 * power the saved filters feature. They are placed above the
 * issue filters on the IssuesInbox page.
 */
const SavedFilters: VoidFunctionComponent = () => (
  <div className="saved-filters-dropdowns">
    <span className="saved-filters-dropdowns__list">
      <SavedFiltersDropdownList />
    </span>
    <span className="saved-filters-dropdowns__actions">
      <SavedFiltersDropdownActions />
    </span>
  </div>
);

export default SavedFilters;
